import { Button, ColumnTypes, Modal, TableWithActions } from '@/components';
import { ROUTERS } from '@/constant';
import { memo } from 'react';

import FormSearchAssignment from './form-search-assignment';
import { useLogic } from './logic';
import { SelectAssignmentModalViewProps } from './type';

const SelectAssignmentModal = (props: SelectAssignmentModalViewProps) => {
	const { ...rest } = props;

	const {
		dataSource,
		columns,
		rowSelection,
		searchFilterRef,
		openModal,
		onToggle,
		handleSave,
		filter,
		handleChangeSelect,
		handleChangeKeyword,
		handleSelectMasterInfo,
		onSearch,
		loading,
		franchiseName,
		openFrom,
		isSearching,
		total,
		onPageChange,
	} = useLogic(props);

	return (
		<div className={props?.containerClassName}>
			<Button secondary onClick={onToggle} className={props?.btnClassName}>
				{props?.textBtn || '추가'}
			</Button>
			<Modal
				open={openModal}
				onCancel={onToggle}
				labelButton="완료"
				onClickButton={handleSave}
				title="배정 선택"
				{...rest}
			>
				<div className="bg-white rounded-2xl">
					{(openFrom === ROUTERS.BM1_03 || openFrom === ROUTERS.BM1_01) && (
						<>
							<p className="text-lg font-bold mb-3">고용주</p>
							<p className="text-base font-medium mb-3">{franchiseName}</p>
						</>
					)}
					<FormSearchAssignment
						{...{
							filter,
							handleChangeSelect,
							handleChangeKeyword,
							handleSelectMasterInfo,
							onSearch,
							openFrom,
						}}
					/>
					<TableWithActions
						{...{ loading, isSearching }}
						actionHidden
						columns={columns as ColumnTypes}
						dataSource={dataSource}
						rowSelection={{ ...rowSelection }}
						scroll={{ y: 400 }}
						rowKey={'assignmentApplicantId'}
						toDetailPathName={ROUTERS.AM1_03}
						idKeyToDetail={'assignmentFranchiseId'}
						searchFilterRef={searchFilterRef}
						containerClassName="px-0"
						pagination={{
							total: total || 0,
						}}
						onPageChange={onPageChange}
					/>
				</div>
			</Modal>
		</div>
	);
};

export default memo(SelectAssignmentModal);
